import { createContext } from 'react';

export const NavContext = createContext({ hidden: false });
export const NavContextProvider = NavContext.Provider;
